module.exports = __webpack_public_path__ + "static/media/agentur_reference_logos_02.82bae883.png";